module.exports = __webpack_public_path__ + "static/media/crop.4fa5e4eb.svg";